import script from "./CreditsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditsDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreditsDialog.vue?vue&type=style&index=0&id=12c7cbab&lang=scss"
import "./CreditsDialog.vue?vue&type=style&index=1&id=12c7cbab&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c7cbab"]])

export default __exports__